import request from '../requesters/search'

export const tagsDiscovery = async () => {
  const response = await request.get<Tag[]>(`/discovery/tags`)

  return response.data || null
}
